export default {"src":"/_next/static/media/add-to-cart-icon.22f083a6.svg","height":56,"width":56,"blurWidth":0,"blurHeight":0};